export const TYPE_MYTEL_REVENUE = "TYPE_MYTEL_REVENUE";
export const TYPE_MYTEL_ERROR_CODE = "TYPE_MYTEL_ERROR_CODE";
export const TYPE_MYTEL_VM = "TYPE_MYTEL_VM";
export const TYPE_MYTEL_MAGICWHEEL = "TYPE_MYTEL_MAGICWHEEL";
export const TYPE_MYTEL_MATH_MATHCH = "TYPE_MYTEL_MATH_MATHCH";
